var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31309 3.48368C3.38087 3.01923 2.34663 3.89992 2.66176 4.88985L4.92542 12.0009C4.99901 12.232 4.99901 12.4802 4.92542 12.7114L2.66176 19.8224C2.34663 20.8124 3.38087 21.6931 4.3131 21.2286L19.9522 13.407C20.8213 12.974 20.8213 11.7382 19.9522 11.3052L4.31309 3.48368Z",
    fill: "#0068FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.870170a250e9aab0cebf64164ad62011.svg";
export { ForwardRef as ReactComponent };